module.exports = __webpack_public_path__ + "static/media/fb.ab549001.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fb.svg
// module id = 30
// module chunks = 0